(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protein-step"] && !Shopify.designMode) return;
  try {
    
$(".bar-main-container").each(function () {
var progress = $(this).find(".bar-percentage[data-percentage]");
var percentage = Math.round(progress.attr("data-percentage"));
$({ countNum: 0 }).animate(
{ countNum: percentage },
{
duration: 2000,
easing: "linear",
step: function () {
// What to do on every count
var pct = Math.round(this.countNum) + "%";
progress.text(pct) && progress.siblings(".bar-container").children(".bar").css("width", pct);
},
}
);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treat-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    // Delay showing the first step until the DOM is fully loaded
    setTimeout(function() {
        showStep('treat-first-step');
    }, 100);

    // Array to store the history of visited steps
    let stepHistory = [];

    // Show the first step initially
    showStep('treat-first-step');

    // Event listener for next buttons
    function setupNextButtonListeners() {
        for (let i = 1; i <= 60; i++) {
            let nextButton = document.getElementById(`nextButton${i}`);
            if (nextButton) {
                nextButton.addEventListener("click", function handleClick() {
                    let nextStepId = document.getElementById(`nextStepId${i}`).value;
                    if (nextStepId.trim() !== "") {
                        showStep(nextStepId);
                        // Remove the event listener temporarily to avoid multiple clicks
                        nextButton.removeEventListener("click", handleClick);
                        // Re-attach the event listener after a short delay
                        setTimeout(() => {
                            nextButton.addEventListener("click", handleClick);
                        }, 100);
                    } else {
                        console.log("Next step ID is empty. No action taken.");
                    }
                });
            }
        }
    }

    setupNextButtonListeners(); // Call the function to set up the event listeners initially

    // Event listener for back buttons
    for (let i = 1; i <= 60; i++) {
        let backButton = document.getElementById(`backButton${i}`);
        if (backButton) {
            backButton.addEventListener("click", function handleClick() {
                console.log(`Back button clicked on step ${i}`);
                let backStepId = document.getElementById(`backStepId${i}`).value;
                console.log("Back step ID:", backStepId);
                if (backStepId.trim() !== "") {
                    showStep(backStepId);
                } else {
                    console.log("Back step ID is empty. No action taken.");
                }
            });
        }
    }

    // Event listeners for pet size selection
    document.querySelectorAll('.slider-container input.slider').forEach(slider => {
        slider.addEventListener('input', function() {
            let selectedSize = this.value; // Get the selected pet size
            let nextStepId = `treat-fourth-step-2${selectedSize}`; // Construct the next step ID
            document.getElementById('nextStepId2').value = nextStepId; // Update the value of nextStepId2
        });
    });


// Event listeners for each icon
document.querySelectorAll('[id^="treat-fourth-step"] .option-image img').forEach(icon => {
    icon.addEventListener('click', function() {
        // Get the parent div's ID suffix (e.g., "20" from "treat-fourth-step-20")
        let divId = this.closest('.treat-step').id;
        let suffix = divId.substring(divId.lastIndexOf('-') + 1);

        // Remove the 'selected' class from all icons in the same div
        let parentDiv = this.closest('.options-container');
        parentDiv.querySelectorAll('.option-image img').forEach(icon => {
            icon.classList.remove('selected');
        });

        // Add the 'selected' class to the clicked icon
        this.classList.add('selected');

        // Get the option's ID and remove the "_id" suffix to get the option number
        let optionId = this.parentElement.id;
        let optionNumber = optionId.substring(6, optionId.lastIndexOf('_'));

        // Construct the nextStepId based on the div's ID suffix and the option number
        let nextStepId = `nextStepId${suffix}`;
        let selectedIconId = optionNumber === "1" ? "Insect" : this.getAttribute('alt');

        // If the selected icon is Insect, replace the value with "Insect"
        if (selectedIconId.startsWith("Insect")) {
            selectedIconId = "Insect";
        }

        // Update the value of the corresponding nextStepId input
        document.getElementById(nextStepId).value = selectedIconId;
    });
});







    // Function to show specific step
    function showStep(step) {
        stepHistory.push(step);
        document.querySelectorAll('.treat-step').forEach(stepElement => {
            stepElement.style.display = stepElement.id === step ? 'flex' : 'none';
        });
        console.log("Step history:", stepHistory);
    }
});



  } catch(e) { console.error(e); }
})();
})();
